export function initSentry() {
  const dsn =
    (import.meta as any).env?.VITE_SENTRY_DSN ||
    (typeof process !== "undefined"
      ? (process.env as any)?.VITE_SENTRY_DSN
      : undefined);
  if (!dsn) return;
  const script = document.createElement("script");
  script.src = "https://browser.sentry-cdn.com/7.120.0/bundle.tracing.min.js";
  script.crossOrigin = "anonymous";
  script.integrity =
    "sha384-QjU8x4Y6C5TnBo0l5XGZg8Qe8V+q5d2hQmFz3e0dSxDi5jIv0o6z9xB1pQvYdGwv";
  script.onload = () => {
    try {
      (window as any).Sentry?.init?.({
        dsn,
        tracesSampleRate: 0.1,
        release: (import.meta as any).env?.VITE_RELEASE,
      });
    } catch {}
  };
  document.head.appendChild(script);
}
